export const translateES = {
  ACADEMIC_PROGRESS: "Progreso académico",
  ACCEPT_SEQUENCE: "Aceptar Secuencia",
  ACTIVE: "Activo",
  ADD_ANOTHER_LANGUAGE: "Agregar idioma",
  ADD_EMAIL: "Agregar email",
  ADD_LANGUAGE: "Agregar idioma",
  ADD_NEW_COMPANY: "Nueva empresa",
  ADD_NEW_LINGO: "Añadir Lingo",
  ADD_NEW_STUDENT: "Nuevo estudiante",
  ADD_NEW_TICKET: "Nuevo Ticket",
  ADD_NEW: "Añadir",
  ADD_TEACHER: "Nuevo Profesor",
  ADD_TELEPHONE: "Añadir teléfono",
  ADD_TO_CONTRACT: "Add al contrato",
  ADDRESS_PLACEHOLDER: "Dirección",
  ADDRESS: "Dirección",
  ADVANCED: "Avanzado",
  ALL_LANGUAGES: "Todos los idiomas",
  ALTERNATIVE_EMAIL: "Email alternativo",
  ANALYTICS: "Analytics",
  APP: "App",
  ASSIGNED_TEACHER: "Profesor Asignado",
  AVAILABLE_PART_CLASSES: "Clases Extras",
  AVARAGE_RATING: "Puntuación media",
  AVERAGE: "Promedio",
  BACK: "Atrás",
  BALANCED: "Balanceado",
  BASIC: "Básico",
  BILINGUAL: "Bilingüe",
  BILLING_HISTORY: "Historial de facturación",
  BILLED_MONTHLY: "facturado mensualmente",
  BIRTH_DATE: "Fecha de nacimiento",
  BTN_ADD_NEW_CONTACT: "Nuevo contacto",
  BTN_ADD_NEW_PLAN: "Adicionar plan",
  BTN_ADD_TEL: "Agregar teléfono",
  BTN_ADD: "Agregar",
  BTN_BACK: "Atrás",
  BTN_BUY_PLAN: "Comprar nuevo plan",
  BTN_CANCEL_ALL_CLASS: "Cancelar todas las secuencias de clase",
  BTN_CANCEL_ONLY_CLASS: "Cancelar esta secuencia de clases",
  BTN_CANCEL: "Cancelar",
  BTN_CLASS_SCHEDULED: "¡Clase Programada!",
  BTN_CLASS_WITHOUT_TECHER: "Clases sin profesor",
  BTN_CLEAR_SEARCH: "Borrar búsqueda",
  BTN_CLOSE: "Cerrar",
  BTN_CONFIRM: "Confirmar",
  BTN_CREATE_ACCOUNT: "Crear mi cuenta",
  BTN_DAYS_TO_REPEAT_CLASS: "Seleccione días para repetir la clase",
  BTN_DELETE: "Borrar",
  BTN_DEMO_CLASS_WITHOUT_TECHER: "Demo clases sin profesor",
  BTN_END_TIME: "Hora de finalización",
  BTN_ENGLISH: "Inglés",
  BTN_HELLO: "Hola",
  BTN_LOGIN: "Entrar",
  BTN_NEW_CLASS: "Nueva Solicitud de",
  BTN_NO_CLASSES_FOUND: "No se encontraron clases",
  BTN_NO: "No",
  BTN_NOT_CANCEL_CLASS: "¡Ups! No quiero cancelar mi clase",
  BTN_NUMBER_CLASSES: "Número de Clases",
  BTN_PORTUGUESE: "Portugués",
  BTN_PROCEED_PAYMENT: "Continuar para pago",
  BTN_REGULAR: "Regular",
  BTN_REPEAT_UNITIL: "Repetir hasta",
  BTN_REQUEST: "Clase",
  BTN_REVERSE_PAYMENT: "Pago inverso",
  BTN_REVERSED_PAYMENT: "Class Reversed",
  BTN_SAVE: "Guardar",
  BTN_SCHEDULE_ADDED: "¡Tu clase ha sido añadida a tu agenda!",
  BTN_SCHEDULE_CLASS: "Agenda una clase",
  BTN_SCHEDULE_NEW_CLASS: "Programa una nueva clase",
  BTN_SCHEDULE: "Programar",
  BTN_SEARCH: "Buscar",
  BTN_SEND: "Enviar",
  BTN_SPANISH: "Español",
  BTN_SPECIFIC: "Específica",
  BTN_START_TIME: "Hora de inicio",
  BTN_UPCOMING_CLASS: "Próximas clases",
  BTN_VIEW_ALL: "Ver todo",
  BTN_VIEW_SCHEDULE: "Ver agenda",
  BTN_VIEW: "Más",
  BTN_YES_LOVE: "Sí, ¡Me encantó!",
  BTN_YES: "Sí",
  BULK_ADD_NEW_STUDENT: "Importar estudiantes",
  BULK_ADD_STUDENT: "Bulk add estudiante",
  BULK_RESULTS: "Resultados",
  BUY_MORE_CLASSES: "Comprar clases",
  CANCEL_ALL_CLASSES_MESSAGE:
    "La cancelación de esta clase dará como resultado que todas las clases listadas arriba sean canceladas.",
  CANCEL_ALL_FIXED_CLASSES_MESSAGE:
    "La cancelación de está clase dará como resultado la cancelación de las clases listadas arriba. Si deseas cancelar todas las secuencias de agendamiento, selecciona “Cancelar todas las secuencias de clases”",
  CANCEL_CLASS: "Cancelar Clase",
  CANCEL_CLASS_OUT_OF_LIMIT: "¡ATENCIÓN! perderás la clase",
  CANCEL_DATE: "Cancelar data",
  CANCEL_LATER_RATE: "Cancelar, calificaré después",
  CANCEL_MESSAGE_REPEAT: "Esta clase forma parte de una secuencia de clases",
  CANCEL_MESSAGE_TICKET: "¿Por qué deseas cancelar tu ticket?",
  CANCEL_MESSAGE: "¿Por qué deseas cancelar tu clase?",
  CANCEL_MESSAGE_OUT_OF_LIMIT:
    "Estas a punto de cancelar tu clase fuera del limite de tiempo permitido (1 hora), por lo que será contada como clase dada ¿Estás seguro de que quieres cancelar tu clase?",
  CANCEL_MY_PLAN: "Cancelar mi plan",
  CANCEL_OPENDED_TICKET: "Cancelar mi ticket abierto",
  CANCEL_PLACEHOLDER: "Por favor; cuéntanos la razón de cancelación",
  CANCEL_PLAN_MENSSAGEM_2:
    "nos gustaría dejar registrado tu nota del 1 al 10 sobre tu experiencia con tus clases y método ¿Podrías ayudarme con eso?",
  CANCEL_PLAN_MENSSAGEM: "Es una pena para nosotros que te vayas 🙁",
  CANCEL_PLAN: "Cancelar Plan",
  CANCEL_IMMEDIATE: "Cancelamiento Inmediato",
  CANCEL_IMMEDIATE_MESSAGE: "Al hacer un cancelamiento inmediato el estudiante no podrá realizar más agendamientos ",
  CANCEL_IMMEDIATE_QUESTION: "¿Estás seguro que deseas hacer un cancelamiento inmediato?",
  CANCEL_TICKET: "Cancelar ticket",
  CANCEL: "Cancelar",
  CANCELED_CYCLE: "cancelado",
  CANCELLED_LINGO: "Cancelada por Lingo",
  CANCELLED: "Cancelada",
  CANCELED: "Cancelada",
  CANCELLED_PLAN: "Plan Cancelado",
  CANCELLED_OUT_lIMIT: "Fuera de Límite",
  CARD_CLASS_ASSOCIATED: "Horarios Asociados",
  CARD_CLASS_ATTENDED: "Esta fue una clase dada?",
  CARD_CLASS_CANCEL: "Cancelar información",
  CARD_CLASS_CANCELLED: "Clase cancelada",
  CARD_CLASS_CONFIRMED: "Confirmado",
  CARD_CLASS_CONTENT: "Contenido de la clase",
  CARD_CLASS_COORDINATOR: "Coordinador",
  CARD_CLASS_DETAILS: "Detalles de la clase",
  CARD_CLASS_DONE: "Clase feita",
  CARD_CLASS_REASON: "Razón",
  CARD_CLASS_STUDENT: "Estudiante",
  CARD_CLASS_TEACHER: "Profesor",
  CARD_LIST_CUSTOM_SERVICE: {
    cancelled: "Cancelado",
    inProgress: "En progreso",
    closed: "Cerrado",
    open: "Abierto",
    companyManager: "Gerente de la compañía",
    b2b: "B2B",
    student: "Estudiante",
    customerService: "Servicio al Cliente",
    teacher: "Profesor",
    affiliate: "Afiliado",
    coordinator: "Coordinador",
  },
  CARD_PLAN_CLASS: "Clases",
  CARD_PLAN_COURSE: "Lingo",
  CARD_PLAN_LEVEL: "Nivel",
  CARD_PLAN_SCHEDULE: "Control de ciclo",
  CARD_PLAN: "Plan",
  CELLPHONE: "Teléfono Móvil",
  CENCELLED_TICKET: "¡Tu ticket ha sido cancelado!",
  CHANCE_PICTURE: "Cambiar",
  CHANGE_PASSWORD_DESCRIPTION: "Establece tu nueva contraseña",
  CHANGE_PASSWORD_TITLE: "Cambiar contraseña",
  CHANGE_PASSWORD: "Cambiar contraseña",
  CHANGE_PLAN: "Cambiar",
  CHANGE: "Cambiar",
  CHANGE_CARD_ERROR: "Su tarjeta no es compatible. Por favor intenta con una tarjeta diferente.",
  CHANGE_CARD_TITLE: "Cambia tu tarjeta de crédito",
  CHECK_IN: "Check In",
  CHECK_OUR_PLANS: "Prueba gratis",
  CHECK_PASS_PLACEHOLDER: "Su contraseña de nuevo",
  CHECK_PASS: "Repita la contraseña",
  CHOOSE_LIST_TEACHER: "Elige una lista",
  CHOOSE_YOUR_PLAN: "Escoge tu plan",
  CLASS_CANCELED: "Clase cancelada",
  CLASS_CANCELED_IN: "Clase cancelada en",
  CLASS_CONVERTED: "Clase convertida",
  CLASS_DETAILS_ACCESS_CLASS: "Acceder a la sala de clase",
  CLASS_DETAILS_BEFORE_CLASS: "Antes de la clase",
  CLASS_DETAILS_EDIT_CLASS: "Editar clase",
  CLASS_LINK: "Sala de Clase",
  CLASS_RATING: "Evaluación de clase",
  CLASS_SCHEDULE_EDIT_MODAL_SUBTITLE: "Edición de la clase",
  CLASS_SCHEDULE_MODAL_SUBTITLE: "Agendamiento de clase",
  CLASS_SUB_CANCELED: "Cancelada",
  CLASS_SUB_CONFIRMED: "Confirmada",
  CLASS_SUB_DONE: "Realizada",
  CLASS_SUB_NOSHOW: "No Show",
  CLASS_SUB_PENDING: "Pendiente",
  CLASS_SUBJECT: "Introduzca el tema de la clase",
  CLASS_TITLE: "Título de la clase",
  CLASS_TOOL: "Herramienta de clase",
  CLASS_TYPE: "Tipo de clase",
  CLASS: "Clase",
  CLASSES_TODAY: "Hoy tienes",
  CLASSES: "Clases",
  CLEAR_FILTERS: "Limpiar Los Filtros",
  CLOSED_TICKET: "Su ticket ha sido cerrado!",
  CLOSED: "Cerrado",
  COPIED_CLIPBOARD: "Copiado al portapapeles",
  CONFIRMED: "Confirmada",
  COMERCIAL_RESPONSIBLE_NAME: "Nombre del Responsable Comercial",
  COMERCIAL_RESPONSIBLE: "Responsable Comercial",
  COMMENTS: "Comentarios",
  COMMERCIAL: "Corporativo",
  COMPANY_INFO: "Compañías",
  COMPANY_MANAGER: "Company Manager",
  COMPANY_NAME: "Nombre de Empresa",
  COMPANY: "Empresa",
  COMPLEMENTARY_EXERCISES: "Ejercicios complementarios",
  CONFIRM_PASS_INVALID: "Por favor, llene su contraseña de confirmación!",
  CONFIRMATION: "Confirmación",
  CONTACT: "Contacto",
  CONTACTS: "Contactos",
  CONTENT: "Contenido",
  MY_CONTENT: "Mi contenido",
  CONTRACT_NUMBER: "Número de contrato",
  CONTRACT: "Contrato",
  CONTRACTS_INFO: "Contratos",
  COORDINATED_LANGUAGES: "Idioma que coordina",
  COORDINATOR: "Coordinadores",
  COPY: "Copiar",
  COUNTRIES: "Países",
  COUNTRY: "País",
  COUPON_INVALID: "Cupón Invalido",
  COUPON_VALID: "Cupón Válido",
  COUPON: "Cupón?",
  COUPONS_INFO: "Cupones",
  CREATOR_USER_ID: "Usuario",
  CURRENT_TIME: "Hora actual",
  CREATE_COMMISSION: "Generar comisión",
  CUSTOMER_SERVICE: "Atención al cliente",
  CYCLE_NAME: "Nombre del ciclo",
  CYCLE: "Ciclo",
  DATA_TIME: "Fecha y hora",
  DATE_CHANGE_PLAN: "Este plan estará activo el día",
  DATE_CREATED: "Criado em",
  DATE_FORMAT: "DD/MM/YYYY",
  DATE: "Fecha",
  DAY: "Dia",
  DAYS: "Dias",
  DELETE_TEACHER: "Eliminar profesor",
  DELETE: "Borrar",
  DEMO_CLASS_CONTENT: "Clase Demo / ",
  DEMO_CLASS_CONTENT1: "Primera Clase",
  DEMO_CLASS: "Clase Demo",
  DEMO_TYPE: "Tipo de demo",
  DESCRIPTION_MODAL_SEND_METHOLOGY: "¡Contenido de Metodología enviado exitosamente!",
  DESCRIPTION_MODAL_SEND_PROGRESS: "¡Contenido de Progreso Académico enviado exitosamente!",
  DESCRIPTION_PLAN_EXPIRED:
    "¡Tu período de prueba ha terminado! ¡Compre un nuevo plan haciendo clic en el botón de abajo!",
  DESCRIPTION: "Descripción",
  DICTATION: "Dictado",
  DOCUMENT_NUMBER: "ID Compañía",
  DONE: "Hecho",
  DONT_HAVE_ACTIVE_PLAN: "Oh, no! Usted no posee ningún plan activo 🙁",
  DOUBLE_CLICK: "Doble click para cambiar",
  DOWNLOAD_APP: "¿Estás desde tu teléfono? Descarga nuestra aplicación. ¡Haz click abajo!",
  DURATION: "Duración",
  ECONOMIC_GROUP: "Grupo Económico",
  EDIT_COMPANY: "Alterar empresa",
  EDIT_CLASS: "Editar",
  EDIT_CONTENT: "Editar Contenido",
  EDIT: "Alterar",
  EMAIL_ERROR: "Correo electrónico invalido",
  EMAIL_INVALID: "Correo electrónico no válido, por favor revise!",
  EMAIL_PLACEHOLDER: "Tu correo electrónico",
  EMAIL_REQUIRED: "E-mail Invalid, please check!",
  EMAIL: "Correo electrónico",
  END_TIME: "Hora de finalización",
  END: "Fin",
  ENGLISH: "Inglés",
  ENTER_COUPON_PLACEHOLDER: "Ingrese el cupón",
  ENTER_NAME: "Ingrese su nombre",
  ENTER_PERCENTAGE_VALUE: "Ingrese el valor en %",
  ENTER_TICKET: "Ingresa número de ticket",
  ERROR_DIALOG: "Algo salió mal, inténtalo de nuevo más tarde.",
  EXCEPTION_TEACHER: "Excepción",
  EXCLUSION_LEVELS: "Niveles de exclusión",
  EXPIRED_ON: "Expira en",
  EXPIRES_ON: "Expira",
  EXTRA_CLASS_PRICE: "Precio de Clase Extra",
  EXTRA_CLASS_USED_PLURAL: "Clases extras usadas",
  EXTRA_CLASS_USED_SINGLE: "Clase extra usada",
  EXTRA_CLASS: "Clase Extra",
  EXTRA_CLASSES: "clases extras",
  EXTRA_EMAIL_PLACEHOLDER: "Otro email",
  EXTRA_EMAIL: "Email alternativo",
  FAVORITE_TEACHER: "Favorito",
  FEMALE: "Femenino",
  FIELD_IS_REQUIRED: "Campo {{fieldName}} es obligatorio",
  FILTER: "Filtrar",
  FILTERS: "Filtros",
  FINAL_TEST: "Prueba final",
  FIRST_ACESS_TEXT_B2B:
    "Antes de comenzar con sus clases, por favor complete su registro y defina una nueva contraseña",
  FIRST_ACESS_TEXT: "Antes de comenzar con sus clases, por favor complete su registro",
  FIRST_CLASS: "Primera Clase",
  FOCUS: "Contenido",
  FORGET_TITLE: "Recuperar contraseña",
  FORGOT_PASS: "¿Olvidaste tu contraseña?",
  FRENCH: "Francés",
  FREE: "Gratis",
  GENDER: "Sexo",
  GENERATE_REPORT: "Generar informes",
  GRADES: "Calificaciones",
  GROUP: "Grupo",
  HAVE_ACCOUNT: "¿Tienes una cuenta?",
  HISTORY: "Historial",
  HOME: "Home",
  HOURS: "Horas",
  HOW_MANY_CLASSES: "Cuántas clases",
  I_AGREE: "Estoy de acuerdo con los",
  I_WANT_TO_SCHEDULE_MY_CLASSES: "Quiero programar mis clases",
  IN_PROGRESS: "En Progreso",
  IN_STOCK: "en stock",
  IN_THIS_TIMEZONE: "En esta zona horaria",
  INACTIVE: "Inactivo",
  INDEX_KEY_ERROR: "es",
  INDEX_KEY_STRING: "nameSpanish",
  INTERMEDIATE: "Intermedio",
  INVALID_FORM_DESCRIPTION: "Completa la información requerida e intentan nuevamente",
  INVALID_FORM_TITLE: "Alert!",
  INVOICE: "Factura",
  ISACTIVE: "Activo",
  ITEM_ACCOUNT: "Mi Cuenta",
  ITEM_CUSTOMER_SERVICE: "Atención al cliente",
  ITEM_SCHEDULE: "Programar",
  ITEM_STUDENTS: "Estudiantes",
  ITEM_TEACHERS: "Profesores",
  LANGUAGE_KEY_STRING: "Spanish",
  LANGUAGE_LEVEL: "Nivel de lenguaje",
  LANGUAGE: "Idioma",
  LANGUAGES: "Idiomas",
  LAST_INTERACTION: "Última interacción",
  LEGAL_NAME: "Nombre Legal",
  LEVEL_BY_STUDENT: "Nivel por el Estudiante",
  LEVEL_SCORE: "Nivel y Calificaciones",
  LEVEL: "Nivel",
  LEVELS: "Niveles",
  LINGO_ADV: "Avanzado",
  LINGO_EMAIL: "Correo Electrónico",
  LINGO_INTER: "Intermedio",
  LINGO: "Lingo",
  LINK_SUBSCRIPTION: "https://www.lingofor.me/lingo-es/lingo_aula_demo.html",
  LIST: "Lista",
  LOAD_MORE: "Ver más",
  LOCAL_CLASS_TIME: "Hora local:",
  LOCALE: "es-es",
  LOGIN_EMAIL: "Email para el inicio de sesión",
  LOGIN_SUBS: "Inscribirse",
  LOGOUT: "Salir",
  MALE: "Masculino",
  MANAGE: "Administrar Plan",
  MANAGE_ACCOUNT_TITLE: "Administrar cuenta",
  MANAGE_HOURS_NOTIME: "No tienes disponibilidad asignada para este día",
  MANAGE_HOURS_TITLE: "Agrega tu disponibilidad para cada día de la semana",
  MAXIMUM_STUDENTS: "El límite máximo de estudiantes por plan alcanzado.",
  MESSAGE_BACK_RESET_CYCLE: "Los Jobs son asíncronos y pueden tardar algunos minutos para finalizar.",
  MESSAGE_EDIT: "Actualizado",
  MESSAGE_INFO_BILINGUE_NATIVO: `Al seleccionar "Nativo" todas tus nuevos agendamientos de clases de inglés serán con profesores nativos. Al seleccionar "Bilingüe" tendrás profesores bilingües.`,
  MESSAGE_INFO_CONTENT_REGULAR: `Regular: El profesor seguirá nuestra metodología y materiales que te permitirán avanzar en nuestros diferentes niveles de estudio.`,
  MESSAGE_INFO_CONTENT_SPECIFIC: `Especifica: El profesor podrá ayudarte con cualquier material que le proporciones y así podrás aclarar dudas especificas, por ejemplo, redactar un email, comprensión de algún documento etc.`,
  MESSAGE_INFO_REPEAT: `En esta opción puedes repetir el agendamiento seleccionando los días y hasta que fecha quieres que se repita el agendamiento.`,
  MESSAGE_CONFIRM_CHANGE_CLASS:
    "Debido a que su clase comienza en menos de 1 hora, hacer cambios en este momento cuenta como una cancelación tardía.\nSi continúa:\nSu clase actual será cancelada y se descontará de sus créditos mensuales.\nEl nuevo horario de clase se reservará como una sesión adicional.",
  MESSAGE_LANGUAGE: "es",
  MESSAGE_MODAL_VERSION:
    "Hemos realizado una nueva actualización y necesitamos cerrar tu sesión para poder aplicarla. Por favor inicia sesión nuevamente.",
  MESSAGE_RESET_CYCLE: "¿De verdad quieres restablecer los ciclos?",
  MESSAGE_SAVE: "Registrado",
  METHODOLOGY: "Metodología",
  MODAL_RELOAD_MESSAGE: "Cambiaste tu zona horaria, ¡Vuelve a iniciar la sesión!",
  MODAL_RELOAD_SUBJECT: "Zona horaria cambiada",
  MODAL_RELOAD_SUBJECT_TIME: "Formato de horario modificado",
  MODAL_RELOAD_MESSAGE_TIME: "Por favor inicie sesión nuevamente",
  MODULE: "Agendamiento",
  MONEY_FORMAT: "US$",
  MONTH: "Mes",
  MONTHLY: "por mes",
  MULTYPLE_CLASSES_MESSAGE:
    "Esta clase forma parte de un agendamiento múltiple. Al aceptarla será asignada la secuencia completa:",
  MULTYPLE_CLASSES: "Clases Múltiples",
  NAME_PLACEHOLDER: "Tu nombre",
  NAME_REQUIRED: "Por favor, coloca tu nombre!",
  NAME: "Nombre",
  NATIVE_LANGUAGE: "Idioma nativo",
  NATIVE: "Nativo",
  NEW_BTN_RESET_CYCLE: "Reinicio de Ciclo",
  NEW_CONTENT: "Nuevo Contenido",
  NEW_USER: "¿No registrado?",
  NEW: "Nueva",
  NIVEL_A0: "Principiante",
  NIVEL_A1: "Prebásico",
  NIVEL_A2: "Básico",
  NIVEL_B1: "Intermedio",
  NIVEL_B2: "Intermedio Superior",
  NIVEL_C1: "Avanzado",
  NIVEL_C2: "Competente",
  NIVEL_DM: "Mantenimiento",
  INTERVIEW: "Entrevista",
  NO_NOTIFICATIONS: "No hay notificaciones",
  NO_RESULTS: "Sin Resultados",
  NO_THANKS: "No Gracias",
  NO: "No",
  NOSHOW_MESSAGE_MODAL: "La clase cambiará de estatus a {{status}}, ¿Deseas continuar?",
  NOSHOW: "Estuvo ausente",
  NOT_AUTHORIZED: "Login no autorizado",
  NOT_INFORMED: "No informado",
  NOT_REGISTERED: "¿No registrado?",
  NOTES_HISTORY: "Notas Historia",
  NOTIFICATION_SETTINGS: "Configuración de mensajes",
  NOTIFICATION_TITLE: "Controla dónde recibes notificaciones de Lingo:",
  NOTIFICATION: "Notificaciones",
  NOTIFICATIONS: "Notificaciones",
  O_K: "Ok",
  OBSERVATION: "Observação",
  OCCUPATION: "Ocupación",
  OOOPS_CANCEL_MY_PLAN: "Ooops! No quiero cancelar mi plan",
  OOOPS_DONT: "Ooops! No quiero cancelar mi billete",
  OPEN_DATE: "Fecha de apertura",
  OPEN_NEW_TICKET: "Abrir Nuevo Ticket",
  OPEN: "Abierto",
  OPTION_CORRECTIONS_RATING_COMMENTS: "Solo me tiene leyendo sin interacción",
  OPTION_EXPLAIN_RATING_COMMENTS: "Habla mi lengua materna excesivamente",
  OPTION_EXPRESSION_RATING_COMMENTS: "Las explicaciones son poco claras y dificultan la comprensión",
  OPTION_LOUD_RATING_COMMENTS: "Siento una mejor conexión con los demás",
  OPTION_OTHER_RATING_COMMENTS: "Otro",
  OPTION_TALK_RATING_COMMENTS: "Habla rápido y no corrige errores",
  OPTIONS: "Opciones",
  OR_LOGIN_TXT: "o inicie sesión con",
  OR_LOGIN: "o inicie sesión con",
  ORAL: "Oral",
  ORDER_COMPLETE: "Confirmación",
  ORDER_DETAILS: "Detalles del Pedido",
  ORDER_REVIEW: "Revisión y Pago",
  ORDER: "Orden",
  OTHER_LANGUAGE: "Otro idioma",
  OTHER_LANGUAGES: "Otros idiomas",
  PARAMETERS: "Parámetros",
  PASS_ERROR: "Campo obligatorio",
  PASS_INVALID_MESSAGE:
    "Mínimo de seis caracteres, por lo menos una letra, un número y un caracter especial como @$!%*#?&[]{},.;<>:/~^´`-_() !",
  PASS_INVALID: "Por favor, llena tu contraseña!",
  PASS_NOT_MATCH: "La contraseñas y su confirmación no son iguales, por favor verifica.",
  PASS_NOTEQUAL_MESSAGE: "Los campos de contraseña deben ser iguales",
  PASS_PLACEHOLDER: "Tu contraseña",
  PASSWORD_CHANGE: "Contraseña alterada con éxito!",
  PASSWORD_CONFIRM: "Confirma tu contraseña",
  PASSWORD_ERROR: "Contraseña o usuario inválido",
  PASSWORD_NOT_MATCH: "Las contraseñas deben ser idénticas",
  PASSWORD: "Contraseña",
  PAYMENT_ID: "Pago ID",
  PAYMENT_METHOD: "Método de pago",
  PAYMENT: "Pago",
  PENDING: "Pendiente",
  PER_MONTH: "por mes",
  PERIOD_END: "Periodo - fin",
  PERIOD_START: "Periodo - inicio",
  PERIOD: "Periodo",
  PERSONAL_DATA: "Datos Personales",
  PERSONAL_INFO: "Datos Personales",
  PERSONAL_INFORMATION: "Información personal",
  PHONE_PLACEHOLDER: "Teléfono",
  PHOTO: "Foto",
  PLAN_BALANCED: "Balanceado",
  PLAN_BUSINESS: "Negocios",
  PLAN_BUY: "Comprar plan",
  PLAN_CONVERSATIONAL: "Conversacional",
  PLAN_DOWNGRADE: "Bajar mi plan",
  PLAN_GRAMMAR: "Gramatical",
  PLAN_NOT_FOUND: "Plan no encontrado",
  PLAN_RENOVATION: "Revertir cancelación",
  PLAN_RENOVATION_MESSAGE:
    "Al revertir la cancelación el sistema continuara con la cobranza automática de forma mensual para su siguiente periodo de clases.",
  PLAN_TRADITIONAL: "Tradicional",
  PLAN_UPGRADE: "Aumentar mi plan",
  PLAN: "Plan",
  PLANS_AND_PRICING: "Planes & Precios",
  PLANS: "Planes",
  PLEASE_TELL_CANCEL_MESSAGE_TICKET: "Por favor dinos por qué quieres cancelar tu ticket",
  PORTUGUESE: "Portugués",
  POWER: "Power",
  PRICE_IN: "Precios en USD",
  PROCEED_TO_PAYMENT: "Continuar para el pago",
  PROFILE: "Perfil",
  PROVIDER: "Proveedor",
  PUSH: "Empuje",
  PUSH_GENERATOR: "Generador de empuje",
  RANDOM: "Aleatório",
  RATE: "Calificar",
  RATING_AVG_INFO: "Calificación",
  RATING_CONFIRMED: "Calificada",
  RATING_DESCRIPTION_TEACHER: "¿Te gustaría tener más clases con este profesor?",
  RATING_INFO_PLURAL: "Calificaciones",
  RATING_INFO_SINGULAR: "Calificación",
  RATING_MODAL_TITLE: "Por favor, califica las siguientes clases",
  RATING_PENDING_INFO_PLURAL: "pendientes",
  RATING_PENDING_INFO_SINGULAR: "pendiente",
  RATING_PENDING: "Pendiente",
  RATING: "Evaluación",
  REAL_LEVEL: "Nivel Real",
  REFER_YOUR_FRIENDS_AND_EARN: "¡El programa Indica y Gana ha alcanzado un nuevo récord de pagos!",
  REFUND: "Reembolso",
  REFUND_MESSAGE: "Al hacer un reembolso el estudiante recibirá la devolución de su último pago.",
  REFUND_QUESTION: "¿Estás seguro que deseas hacer el reembolso?",
  REMEMBER_ACCESS: "Recuérdame",
  REPEAT: "¿Quieres repetir este horario otros días?",
  REPORT: "Informe",
  REQUESTED_PLAN: "Plan solicitado",
  REQUIRED_FIELD: "Obligatorio",
  REQUIRED: "Obligatorio",
  RESET_CYCLE: "en el siguiente ciclo de reinicio",
  RESETS_ON: "Reinicia en",
  RESIDENCIAL: "Residencial",
  RESEND: "Reenviar",
  REVIEW_AND_PAY: "Revisar y Pagar",
  REVIEW_INFORMATION: "Revisa tu información",
  REVIEW_PLAN: "Revisa tu plan",
  REVIEW_YOUR: "Revisa tu ",
  SAVE_FORM_DESCRIPTION: "La información ha sido guardada!",
  SAVE_FORM_TITLE: "Completado!",
  SAVE: "Salvar",
  SCHEDULE: "Agenda",
  SCHEDULING_CONTROL: "Control de ciclo",
  SEARCH_USER: "Buscar usuario",
  SELECT_LANGUAGE_LEVEL: "Por favor llena tu nivel del idioma!",
  SELECT_LANGUAGE_PLAN_TITLE: "Selecciona el idioma del plan:",
  SELECT_LANGUAGES: "Por favor llena tu idioma!",
  SELECT_TEACHER: "Seleccione un profesor",
  SELECT_TIME_FORMAT: "Seleccione el formato del horario",
  SELECT_TIMEZONE: "Selecciona tu zona horaria",
  SELECT_THE_LINK: "Selecciona el link que deseas enviar:",
  SELECT: "Seleccionar",
  SEND: "Mandar",
  SEQUENTIAL_CLASS_MESSAGE: "Esta clase forma parte de la siguiente secuencia de clases:",
  SETTINGS_NOTIFY: "Opciones de notificación",
  SETTINGS: "Configuraciones",
  SHARE: "Síguenos en:",
  SHCEDULING_IN: "Agendado en el",
  SHOWING_OF: "de",
  SHOWING: "Mostrando",
  SIGN_UP: "Revisa nuestros planes",
  SIGNATURE_DATE: "Fecha de firma",
  SIGNATURE_PENDING: "Firma pendiente",
  SINCE: "Desde",
  SING_IN: "Haga Login",
  SOCIAL_MEDIA: {
    LOGIN_ERROR: "Error al intentar iniciar sesión",
  },
  SOMETHING_WENT_WRONG: "Algo salió mal",
  SPANISH: "Español",
  START_TIME: "Hora de inicio",
  START: "Inicio",
  STATUS_CHANGE: "Cambio de estado",
  STATUS: "Estado",
  STRUCTURE: "ESTRUCTURA",
  STUDENT_ADDRESS: "Elegir la zona horaria",
  STUDENT_COMPANY_NAME: "Nombre de la empresa del estudiante",
  STUDENT_COMPANY: "Nombre de la empresa",
  STUDENT_EMAIL: "Correo electrónico del estudiante",
  STUDENT_LINK: "Link del estudiante",
  STUDENT_MESSAGE_EDIT: "Estudiante actualizado",
  STUDENT_MESSAGE_SAVE: "Estudiante registrado",
  STUDENT_NAME: "Nombre del estudiante",
  STUDENT_OCCUPATION: "Cargo del estudiante",
  STUDENT_PHONE: "Teléfono del estudiante",
  STUDENT_TOOL_ID: "ID del estudiante",
  STUDENT: "Estudiante",
  STUDENTS_TIMEZONE: "Timezone del Alumno",
  STUDENTS: "Alumnos",
  SUBSCRIPTION: "Suscripción",
  SUBSCRIPTION_DATE: "Fecha de suscripción",
  SUBTYPE: "Subtipo",
  SUCCESS_MESSAGE: "¡Éxito!",
  SUCCESS_CHANGE_CARD: "Tu tarjeta ha sido actualizada, el próximo pago será descontado de ella.",
  SUCESS_CANCEL_PLAN: "Tu plan ha sido cancelado. Podrás agendar tus clases hasta el final de tu ciclo de facturación.",
  SUCESS_CANCEL_PLAN_MANAGE: "Plan ha sido cancelado.",
  SWARMING_TITLE: "Alta Demanda de Clases",
  TARGET_CLASSES_PER_MONTH: "Target classes per month",
  TEACHER_AVERAGE_RATING: "Calificación promedio del profesor",
  TEACHER_LINK: "Link del profesor",
  TEACHER_NAME: "Nombre del Profesor",
  TEACHER_TYPE: "Tipo del Profesor",
  TEACHER: "Profesor",
  TEACHERS: "Profesores",
  TEL_REQUIRED: "Número inválido, por favor intenta nuevamente!",
  TELEPHONE_COMMERCIAL: "Teléfono Comercial",
  TELEPHONE_MOBILE: "Teléfono Móvil",
  TELEPHONE: "Teléfono",
  TELL_US_CANCEL_MY_PLAN: "Por favor, podrías comentarnos la razón de la cancelación",
  TERMS_OF_USE: "Online Learning Agreement",
  TERMS_OF: "términos de uso ",
  THIS_PLAN: "Este plan será",
  TICKET_ID: "Ticket #",
  TICKET_MESSAGE: "Tu ticket ha sido abierto",
  TICKET_NUMBER: "Número de Ticket",
  TICKET_TITLE: "¡Felicidades!",
  TICKET_VIEW: "Ver ticket",
  TICKETS: "Tickets",
  TIME_SLOT_DURATION: "Duración del intervalo",
  TIMEZONE: "Hora local",
  TITLE_CONFIRM_CHANGE_CLASS: "Aviso importante: Política de reprogramación tardía",
  TITLE_MODAL_SEND: "¡Datos Actualizados!",
  TITLE_MODAL_VERSION: "¡Nueva versión disponible!",
  TITLE_PLAN_EXPIRED: "Tu plan ha expirado!",
  TITLE: "Título",
  TODAY: "Hoy",
  TOOL_ID: "ID de herramienta",
  TOTAL_CLASSES: "Total de clases",
  TOTAL_CYCLES: "Total de ciclos",
  TOTAL_QUIZZES: "Total de quizzes",
  TRAINING: "Entrenamiento",
  TRANSACTION_ID: "ID de transacción",
  TRIAL_CLASS: "Clase de Prueba",
  TRY_AGAIN: "Inténtalo de nuevo",
  TYPE_MESSAGE: "Escribe un mensaje...",
  TYPE: "Tipo",
  UNITARY_VALUE: "Valor Unitario",
  UNTIL: "Hasta",
  UPDATE_SCREEN: "Actualizar",
  USER_INFO: "Sus datos",
  USERS: "Usuarios",
  VALID_FORM_DESCRIPTION: "¡Contraseña alterada con éxito!",
  VALID_FORM_TITLE: "Éxito",
  VALIDATE_SCHEDULE_DATE_PAST: "La fecha no puede ser pasada",
  VALIDATE_SCHEDULE_DATE: "Se requiere fecha",
  VALIDATE_SCHEDULE_FOCUS: "Se requiere contenido",
  VALIDATE_SCHEDULE_LANG: "Se requiere idioma",
  VALIDATE_SCHEDULE_NATIVE_BILINGUE:
    "La opción de nativo/bilingüe no ha sido seleccionada, es necesario escoger el tipo de profesor para esta clase",
  VALIDATE_SCHEDULE_NUM_CLASSES: "Se requiere Número de classes",
  VALIDATE_SCHEDULE_PLAN: "Se requiere plan",
  VALIDATE_SCHEDULE_REPEATEND: "Se requiere Repetir hasta",
  VALIDATE_SCHEDULE_START: "Se requiere Hora de inicio",
  VALIDATE_SCHEDULE_WEEKREPEAT: "Se requiere al menos un día",
  VALIDATE: "Visar",
  VALIDATION_ERROR: "Error de validación",
  VALUE: "Valor",
  VIEW_MORE: "Ver más",
  VIEW: "Ver",
  VIEW_CONTRACT: "Ver contrato",
  WEBSITE: "Sitio web",
  WEEK: "Semana",
  WEEK_FRIDAY: "Viernes",
  WEEK_MONDAY: "Lunes",
  WEEK_SATURDAY: "Sábado",
  WEEK_SUNDAY: "Domingo",
  WEEK_THURSDAY: "Jueves",
  WEEK_TUESDAY: "Martes",
  WEEK_WEDNESDAY: "Miércoles",
  WELCOME_TITLE: "Bienvenido a ",
  WHAT_TYPE_OF_TEACHER: "¿Qué tipo de profesor quieres tener en esta clase?",
  WHATSAPP: "WhatsApp",
  WHATSAPP_SUPPORT: "Soporte WhatsApp",
  WITHOUT_TEACHER: "Sin profesor",
  WORDOFTHEDAY: "Palabra del día",
  WRITING: "Escritura",
  YES: "Si",
  YOUR_EXTRA_CLASSES_IS_ALL_SET: "Tus clases extra están listas",
  YOUR_PLAN: "Tu plan será",
  YOUR_TIMEZONE: "Tu zona horaria",

  PRODUCTIVITY: "Productividad",
  SALES_LINK: "Link para referir",
  DISCLOSURE: "Divulgación",
  TRANSACTIONS: "Transacciones",
  CONTRACTS: "Contratos",
  BRONZE: "Bronce",
  BLUE: "Blue",
  GOLD: "Gold",
  SILVER: "Silver",
  PLATINUM: "Platinum",
  SALES: "referidos",
  SALES1: "Referidos",
  PRIVILEGE: "Privilegio",
  PRIVILEGES: "Privilegios",
  CONTRACT_PENDING: "Tu contrato está pendiente",
  MONTHLY_PRIVILEGES: "Los privilegios son mensuales.",
  PRODUCTIVITYINFO1: "Necesitas",
  PRODUCTIVITYINFO2: "referidos para alcanzar el nivel",
  MY_TRANSACTIONS: "Mis transacciones",
  MY_COMMISSION: "Mi comisión",
  MINIMUM_WITHDRAWAL1: "Mínimo de",
  MINIMUM_WITHDRAWAL2: "para retiro",
  VISITS: "Visitas",
  DEMOS: "Demos",
  CONVERSIONS: "Conversiones",
  FLAT: "Plan",
  TOTAL: "Total",
  MENU: "Menú",
  MY_SALES_LINK: "Mi link para referir",
  SHORT_LINK: "Link corto",
  SHARE_SOCIAL_NETWORKS: "Comparte en las redes sociales",
  LINK_COPIED: "Enlace copiado al portapapeles.",
  MESSAGE_SHARE: "teste mensagem lingo",
  CURRENT_BALANCE: "Saldo actual",
  CONCLUDED: "Concluido",
  WITHDRAWAL: "Retirado",
  PAYMENTO_LINGO: "Pago de Lingo",
  COMMISSION: "Comisión",
  CONVERSION: "Conversión",
  SUBTITLE: "Leyenda",
  SUBTITLE_COMMISSION: "Valor vs Tiempo",
  SUBTITLE_CONVERSION: "Referidos vs Tiempo",
  AFFILIATE: "Afiliado",
  AFFILIATES: "Afiliados",
  ADD_PROFILE_PHOTO: "Añade una foto de perfil.",
  ADD_TAX_INFORMATION: "Añade tu información fiscal.",
  ADD_PAYMENT_INFORMATION: "Selecciona un método de pago",
  TERMS_OF_USE_AFFILIATE: "Condiciones de uso",
  BTN_ACCEPT: "Acepto",
  PROFILE_PICTURE: "Foto de perfil",
  SUCCESS_MESSAGE_PHOTO: "¡Tu foto ha sido agregada!",
  PAYMENT_METHOD_LABEL: "Ingrese el método y usuario de la cuenta.",
  SUCCESS_MESSAGE_PATMENT_METHOD: "¡Sus datos de pago se han agregado correctamente!",
  FISCAL_DOCUMENT: "¿Cuál es tu número de documento fiscal?",
  OTHER: "Otro",
  BRAZILIAN_ADDRESS: "Dirección brasileña",
  AMERICAN_ADDRESS: "Dirección estadounidense",
  ADRESSE_COLOMBIENNE: "Dirección colombiana",
  ADRESSE_MEXICAINE: "Dirección Mexicano",
  ALERT_TAX_INFORMATION:
    "Importante: Seleccionaste la opción para residentes fiscales de EE. UU. Toda la información debe ser verificada porque se utilizará para generar el 1099.",
  SUCCESS_MESSAGE_TAX_INFORMATION:
    "La información se registró satisfactoriamente, Se ha enviado el contrato a tu email listo para tu firma.",
  ALERT_MESSAGE_TAX_INFORMATION: "Se ha enviado el contrato a tu email listo para tu firma.",
  TAX_INFORMATION: "Informaciones fiscales",
  CITY: "Ciudad",
  STATE: "Estado",
  ZIPCODE: "Código postal",
  CITIZENSHIP_COUNTRY: "¿De qué país es tu ciudadanía?",
  WHERE_LIVE_COUNTRY: "¿En qué país resides?",
  MODAL_PAYAMENT_ALERT01:
    "Ingresa el correo electrónico que utilizas para iniciar sesión en la plataforma de pago seleccionada. ",
  MODAL_PAYAMENT_ALERT02: "Importante: ",
  MODAL_PAYAMENT_ALERT03:
    " debes revisar tu correo electrónico, ya que una vez procesado el pago no podemos solicitar reembolso.",
  SALES_LINK_PT: "Link en portugués",
  SALES_LINK_ES: "Link en español",
  SALES_LINK_US: "Link en inglés",
  BONUS: "Bonificación",
  CORPORATE_NAME: "Razón Social",
  COMMUNICATION_LANGUAGE: "Idioma de Comunicación",
  PHYSICAL_PERSON: "Persona Natural",
  LEGAL_PERSON: "Persona Jurídica",
  AFFILIATE_PROGRAM_TITLE: "Programa de afiliado ($)",
  AFFILIATE_PROGRAM_DESCRIPTION: "¡Regístrate gratis y empieza a recibir!",
  BE_AFFILIATED: "Indique y gane",
  PAID: "Pagado",
  NO_ITEMS_FOUND: "No se encontraron artículos...",
  TOTAL_LIFETIME_COMMISSION: "Comisión total vitalicia",
  PAY_ALL: "Pagar todas",
  MODAL_AFFILIATE_STUDENT_TITLE1: "Gana hasta ",
  MODAL_AFFILIATE_STUDENT_TITLE2: "$ 75.20 dólares",
  MODAL_AFFILIATE_STUDENT_TITLE3: "por plan referido",
  MODAL_AFFILIATE_STUDENT_SUBTITLE1: "Sé uno de los primeros afiliados de Lingofor.me",
  MODAL_AFFILIATE_STUDENT_SUBTITLE2: "¡Genera ingresos extra en dólares!",
  MODAL_AFFILIATE_STUDENT_BUTTON: "¡Empieza ahora!",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE1: "1 - Comparte tu enlace para referir",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE2: "2 - Agendamiento de clase demo",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE3: "3 - Recibe la comisión en dólares",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE1: "Comparta tu link para referir exclusivo con amigos, familiares y colegas.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE2: "Cada estudiante referido al curso puede programar una prueba gratuita.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE3: "Gane una comisión de hasta $75.20 por cada referencia exitosa.",
  ITEM_CARD_AFFILIATE1: "Pago en Dólares.",
  ITEM_CARD_AFFILIATE2: "Gane una comisión de hasta $75.20 por cada referencia exitosa.",
  ITEM_CARD_AFFILIATE3: "Pagos quincenales.",
  ITEM_CARD_AFFILIATE4: "Cuantas más personas recomiendes, mayor posibilidad de planes contratados.",
  ITEM_CARD_AFFILIATE5: "Refiere en cualquier país, tenemos estudiantes en más de 34 países.",
  ITEM_CARD_AFFILIATE6: "Más de 400.000 clases realizadas en la plataforma.",
  ITEM_CARD_AFFILIATE7: "Excelentes comentarios de los estudiantes.",
  ITEM_CARD_AFFILIATE8: "Todos los planes son multilingües.",
  ITEM_CARD_AFFILIATE9: "Planes mensuales y sin penalización de cancelación para los estudiantes.",
  JANUARY: "Enero",
  FEBRUARY: "Febrero",
  MARCH: "Marzo",
  APRIL: "Abril",
  MAY: "Mayo",
  JUNE: "Junio",
  JULY: "Julio",
  AUGUST: "Agosto",
  SEPTEMBER: "Septiembre",
  OCTOBER: "Octubre",
  NOVEMBER: "Noviembre",
  DECEMBER: "Diciembre",
  JAN: "Ene",
  FEB: "Feb",
  MAR: "Mar",
  APR: "Abr",
  JUN: "Jun",
  JUL: "Jul",
  AUG: "Ago",
  SEP: "Sep",
  OCT: "Oct",
  NOV: "Nov",
  DEC: "Dic",

  CREATE_YOUR_ACCOUNT: "Crea tu cuenta",
  NAME_FULL: "Nombre completo",
  BTN_NEXT: "Siguiente",
  SELECT_COUNTRY: "Selecciona tu país",
  REVIEW_SUBSCRIPTION_TITLE: "Revisa tu suscripción",
  ABBREVIATED_DISCOUNT: "Desc.",
  REVIEW_SUBSCRIPTION_TEXT1: "Tu plan se renueva de forma automática",
  REVIEW_SUBSCRIPTION_TEXT2: "Podrás cancelar la renovación automática cuando quieras.",
  REVIEW_SUBSCRIPTION_TEXT3: "La cuota mensual del plan elegido es de",
  REVIEW_SUBSCRIPTION_TEXT4: " ,la cual se cobrará mensualmente conforme el día del registro.",
  PRIVACY_TERMS_TEXT: "Acepto los términos de renovación automática anteriores.",
  ALL_OUR_PLANS: "Todos nuestros planes son multilingües.",
  SIGN_FOR_LINGO: "Al registrarse en Lingo, acepta los términos anteriores y nuestra",
  PRIVACY_POLICY: "Política de privacidad.",
  BTN_BUY: "Comprar",
  THANKS: "¡Gracias!",
  A_PARTNER: "Aliado",
  WELCOME_TO_LINGO: "¡Tu proceso de compra ha concluido! ¡Bienvenido a Lingo!",
  WELCOME_TO_LINGO_CHANGE: "¡Tu proceso de compra ha concluido!",
  BTN_MANAGR_ACCOUNT: "Acceso a mi usuario",
  MINUTE_CLASSES_MONTH: "Clases de 30 min por mes",
  ITEM_CARD_INFO1: "Planes multilingües",
  ITEM_CARD_INFO2: "Clases privadas con profesores en vivo.",
  ITEM_CARD_INFO3: "Clases prácticas enfocadas en la conversación.",
  ITEM_CARD_INFO4: "Agendamiento libre (24/7)",
  ITEM_CARD_INFO5: "Sin cuota de inscripción, materiales ni penalización por cancelación.",
  ITEM_CARD_INFO6: "Facturación mensual y automática.",
  ITEM_CARD_INFO7: "Las clases no son acumulables de un periodo al siguiente.",
  ITEM_CARD_INFO8: "Aplicaciones para",
  INVALID_PASS1: " Al menos 6 carácter",
  INVALID_PASS2: " Al menos 1 letra",
  INVALID_PASS3: " Al menos 1 número",
  INVALID_PASS4: " Al menos 1 carácter especial",
  INVALID_PASS5: " Ambas contraseñas deben ser iguales.",
  INVALID_FORM_CHECKOUT1: "El nombre es requerido",
  INVALID_FORM_CHECKOUT2: "El email es requerido",
  INVALID_FORM_CHECKOUT3: "El email es invalido, por favor revisa tu email.",
  INVALID_FORM_CHECKOUT4: "El número telefónico es requerido",
  INVALID_FORM_CHECKOUT5: "El país es requerido",
  INVALID_FORM_CHECKOUT6: "Es necesario aceptar las condiciones para continuar",
  INVALID_FORM_CHECKOUT7: "El usuario",
  INVALID_FORM_CHECKOUT7_1: " ya existe, has click en el botón de acceder a mi usuario para continuar.",
  INVALID_FORM_CHECKOUT8: "No se puede cargar la información del plan, inténtelo más tarde.",
  INVALID_FORM_CHECKOUT9: "El campo de razón social es obligatorio",
  INVALID_FORM_CHECKOUT10: "¡La fecha de nacimiento es obligatoria!",
  INVALID_FORM_CHECKOUT11: "¡Debe tener más de 18 años para registrarse!",
  INVALID_FORM_CHECKOUT12: "El campo de idioma es obligatorio",
  INVALID_FORM_CHECKOUT13: "¡Por favor, complete el reCAPTCHA!",

  SAME: "Misma",
  BEST_SELLER: "Best Seller",
  CARD: "Tarjeta",
  NEW_CARD: "Introduce una nueva tarjeta como método de pago.",
  NEXT_CYCLE: "Su suscripción cambiará en la próxima renovación del ciclo de pago.",
  ACTIVATION: "Activación",
  SCHEDULED: "Programada",
  IMMEDIATE: "Inmediata",
  CHANGE_NOW: "Tu suscripción se cambiará al nuevo plan ahora mismo.",

  NEW_MULTI_STUDENT: "FELICIDADES",
  SUBTITLE01: "A partir de ahora tu plan es MULTIIDIOMAS",
  SUBTITLE02: "Estudia inglés, español, portugués y francés (próximamente), ¡sin pagar más por ello!",

  TITLE_ALERT_NEWS: "Nueva Actualización",
  SUBTITLE01_ALERT_NEWS: "¡Dile adiós a los post-its y a revisar dos veces tu agenda! 🚀",
  SUBTITLE02_ALERT_NEWS:
    "Nuestra nueva actualización ya está aquí: Integración total con Google Calendar. Ahora, tus clases aparecen mágicamente en tu calendario personal en cuanto creas un agendamiento nuevo.",
  SUBTITLE03_ALERT_NEWS: "✅ Cero olvidos",
  SUBTITLE04_ALERT_NEWS: "✅ Todo en un solo lugar.",
  SUBTITLE05_ALERT_NEWS: "✅ Actualización en tiempo real.",
  SUBTITLE06_ALERT_NEWS:
    '¡Pruébalo hoy mismo! Ve al menu "mi cuenta" > notificaciones y conecta tu cuenta Google con lingo.',

  REPORT_FORM: "Reporte",
  CLASSES_HELD: "Contenido dado",
  CLASS_COMMENTARY: "Comentario",
  EVALUATED: "Completado",
  ASSESSED_LATE: "Concluido con retraso",
  SELECT_STUDENT_LEVEL: "Seleccione el nivel del estudiante",
  STUDENT_PERSONAL_PROFILE: "Contenido propuesto",
  ADD_SPECIFIC_CLASS: "Añadir contenido específico",
  CLASS_NOT_COMPLETED: "Contenido incompleto",
  PAGE: "Página",
  SPECIFY_NEXT_TEACHER: "Especifique dónde debe continuar el próximo profesor:",
  MORE_CLASSES: "Más contenido",
  COMMUNICATE_SOMETHING_COORDINATOR: "¿Deseas comunicar algo al coordinador?",
  ENTER_STATEMENT_HERE: "Escribe el comunicado aquí",
  YES_COMMUNICATE: " ¡SI, quiero comunicar!",
  FINISH: "Finalizar",
  NO_FINISH: "¡No, solo finalizar!",
  ACCEPT: "Aceptar",
  STUDENT_LEVEL: "Nivel del estudiante",
  FILL: "Llenar",
  EXPIRES_AT: "Expira en:",
  PENDENT: "Llenar",
  DELAYED: "Concluido con retraso",
  PAGE_COMMENT_REQUIRED: "Página y comentario requeridos.",
  TITLE_ALERT_ADD_CONTENT_SPECIFIC: "Contenido Específico",
  DESCRIPTION_ALERT_ADD_CONTENT_SPECIFIC:
    "El contenido específico es exclusivamente para clases en las que no se utilizó material de lingofor.me o para clases de nivel M1. ¿Estás seguro de que deseas continuar con este tipo de contenido?",

  AFTER_CLASS: "Después de clase",
  FILL_FORM: "Llenar formulario",
  FILL_REPORT: "Llenar Reporte",
  PREVIOUS_CLASSES: "Clases anteriores",
  LATEST_APPOINTMENTS: "Últimos agendamientos",
  CODE: "Código",
  STUDENT_DESCRIPTION: "Descripción del estudiante",
  CLASS_NOT_COMPLETED_CONTINUE: "Clase no completada. Continuar en:",
  WAITING_TEACHER_UPDATE: "Esperando actualización del profesor",
  CLASS_EXPIRED: "Clase expirada",
  WAITING_TEACHE_UPDATE: "Esperando actualización del profesor",

  DETAIL: "Detalle",
  OUT_OF_LIMIT: "Fuera del Límite",
  FORMS_FILL: "Formularios a Completar",
  FORM_DETAIL: "Detalle del Formulario",
  UPCOMING_MATERIALS: "Próximos Materiales",
  FIRST_CLASS_CONTENT:
    "Ahora puedes seguir tu progreso con mayor precisión en el nuevo menú de contenido. Tendrás tus próximos materiales y el historial de lo que viste en tus últimos 3 agendamientos.",

  TITLE_STUDENT_CONTENT: "Novedades en Lingofor.me",
  DESCRIPTION_STUDENT_CONTENT:
    "Ahora puedes seguir tu progreso con mayor precisión en el nuevo menú de contenido. Tendrás tus próximos materiales y el historial de lo que viste en tus últimas 3 citas.",

  DEPARTMENT: "Departamento",
  REPORT_UPDATE: "Actualización de Reporte",

  LOADING: "Cargando...",
  QUESTIONNAIRES: "Cuestionarios",
  OPEN_MODAL_QUESTIONNAIRES: "Información personal para inmigración",
  NO_QUESTIONS_AVAILABLE: "No hay preguntas disponibles",
  MESSAGE_ALERT_QUESTIONNAIRES:
    "El siguiente cuestionario es esencial para comenzar su práctica de entrevista de inmigración, ya que contiene toda la información personal que nuestros instructores necesitan corregir y verificar. Por favor, responda cada pregunta con claridad y detalle.",

  CONNECT_YOUR_GOOGLE_ACCOUNT:
    "Conecta tu cuenta Google para sincronizar tus agendamientos con tu Calendario Personal.",
  GOOGLE_CALENDAR: "Calendario de Google",
  SYNC_YOUR_GMAIL_ACCOUNT: "Sincronice su cuenta Gmail.",
  MICROSOFT_OUTLOOK: "Microsoft Outlook",
  SYNC_WITH_YOUR_OUTLOOK_ACCOUNT: "Sincronice con su cuenta Outlook",
  CONNECT: "Conectar",
  CONNECTED: "Conectado",
  CONNECTING: "Conectando",
  GO_TO_NOTIFICATIONS: "Ir a notificaciones",

  SUGESTIONS: "Sugerencias",
  TYPE_YOUR_SUGGESTIONS: "Escribe tus sugerencias",

  AI_PRACTICE: "Practica con Lingo AI",
  AI_PRACTICE_TITLE: "Practica con Lingo AI",
  AI_PRACTICE_DESCRIPTION: "Lingo AI generará ejercicios personalizados para que practiques fuera de clase.",
  AI_PRACTICE_LIST_DESCRIPTION:
    "La siguiente lista muestra los temas más recientes tratados en tus clases. Puedes seleccionar hasta {{count}} de ellos y Lingo AI generará ejercicios según tu nivel para que puedas practicar.",
  AI_PRACTICE_TOPICS_AVAILABLE: "Temas disponibles para practicar",
  AI_PRACTICE_TEACHER_RECOMMEND: "Lo que tus profesores te recomiendan practicar...",
  AI_PRACTICE_SELECT_TOPICS: "Seleccionar temas",
  AI_PRACTICE_MY_HISTORY: "Mi historial",
  AI_PRACTICE_GENERATE: "Generar",
  AI_PRACTICE_EMPTY_TITLE:
    "Después de tu primera clase de este idioma se habilitará la opción de generación de ejercicios para que puedas comenzar a practicar.",

  MY_HISTORY_EXERCISES: "Ejercicios",
  MY_HISTORY_TOPICS: "Temas",
  MY_HISTORY_CREATION_DATE: "Fecha de creación",
  MY_HISTORY_LAST_UPDATE: "Última actualización",
  MY_HISTORY_SCORE: "Puntaje",
  MY_HISTORY_SUGGESTIONS: "Sugerencias de Lingo AI",
  MY_HISTORY_REDO: "Responde nuevamente los mismos ejercicios que ya hiciste y mejora tu nota.",
  MY_HISTORY_GENERATE_NEW: "Genera nuevos ejercicios diferentes del mismo tópico y practica más.",
  MY_HISTORY_NO_ITEMS_FOUND:
    "Aun no has generado tus primeros ejercicios, haz clic en el botón 'Atrás' y selecciona los tópicos que deseas practicar y haz click en el botón 'Generar'",
  MY_HISTORY_VIEW_RESULTS: "Haz clic para ver los resultados",

  IDEAL_FOR_RESUMING_YOUR_STUDIES_WITH_EASE: "Ideal para retomar tus estudios con facilidad.",
  MORE_FREQUENCY_TO_ACCELERATE_YOUR_PROGRESS: "Mayor frecuencia para acelerar tu progreso.",
  PREMIUM_PLAN_FOR_MAXIMUM_PROGRESS: "Plan Premium para un progreso máximo.",
};
